var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24841 15.696L1.29688 14.3931V1.60718L6.24841 0.304199V15.696Z",
    fill: "#F8E868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23438 14.3931V1.60718L6.24841 0.550903V0.304199L1.29688 1.60718V14.3931L6.24841 15.696V15.4493L2.23438 14.3931Z",
    fill: "#E39C2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23499 8C5.23499 8.32922 4.96814 8.59595 4.63904 8.59595C4.30981 8.59595 4.04297 8.32922 4.04297 8C4.04297 7.67078 4.30981 7.40405 4.63904 7.40405C4.96814 7.40405 5.23499 7.67078 5.23499 8Z",
    fill: "#EEF0F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9792 6.99951H6.24854V9.55237H10.9792V10.9805L14.5385 8.27588L10.9792 5.57129V6.99951Z",
    fill: "#D15573"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24854 6.99951H7.18604V9.55237H6.24854V6.99951Z",
    fill: "#C21D44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24854 1.77588H9.5061V6.99951H6.24854V1.77588Z",
    fill: "#EEF0F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24854 9.55249H9.5061V14.224H6.24854V9.55249Z",
    fill: "#EEF0F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24854 1.77588H7.18604V6.99951H6.24854V1.77588Z",
    fill: "#CAD8EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24854 9.55249H7.18604V14.224H6.24854V9.55249Z",
    fill: "#CAD8EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24854 9.55249H8.49268V13.2106H6.24854V9.55249Z",
    fill: "#72869E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24854 2.78955H8.49268V6.99976H6.24854V2.78955Z",
    fill: "#72869E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24854 9.55249H7.18604V13.2106H6.24854V9.55249Z",
    fill: "#536275"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24854 2.78955H7.18604V6.99976H6.24854V2.78955Z",
    fill: "#536275"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63379 8.50073H9.16504V8.03198H9.63379V8.50073ZM8.85254 8.50073H8.38379V8.03198H8.85254V8.50073Z",
    fill: "#474747"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0625 14.5736L6.48279 16V0L1.0625 1.42639V14.5736ZM1.53125 1.78772L6.01404 0.608032V15.392L1.53125 14.2123V1.78772Z",
    fill: "#474747"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63904 7.16943C4.18115 7.16943 3.80859 7.54199 3.80859 7.99988C3.80859 8.45776 4.18115 8.83032 4.63904 8.83032C5.09692 8.83032 5.46936 8.45776 5.46936 7.99988C5.46936 7.54199 5.09692 7.16943 4.63904 7.16943ZM4.63904 8.36145C4.43958 8.36145 4.27734 8.19934 4.27734 7.99988C4.27734 7.80042 4.43958 7.63831 4.63904 7.63831C4.83838 7.63831 5.00061 7.80042 5.00061 7.99988C5.00061 8.19934 4.83838 8.36145 4.63904 8.36145Z",
    fill: "#474747"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27173 6.12439H9.74048V1.5415H7.10791V2.01025H9.27173V6.12439Z",
    fill: "#474747"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27173 13.9896H7.10791V14.4584H9.74048V10.4275H9.27173V13.9896Z",
    fill: "#474747"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9259 8.27612L10.7449 5.09912V6.76538H7.10791V7.23413H11.2136V6.04395L14.1511 8.27612L11.2136 10.5083V9.31824H7.10791V9.78699H10.7449V11.4532L14.9259 8.27612Z",
    fill: "#474747"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25818 6.12463H8.72705V2.55518H7.10791V3.02393H8.25818V6.12463Z",
    fill: "#474747"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72705 10.4275H8.25818V12.9762H7.10791V13.4449H8.72705V10.4275Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLogoutIcon);
export default __webpack_public_path__ + "static/media/my_logout_icon.5ace12e853e5c97c0fe8e1109913bbc9.svg";
export { ForwardRef as ReactComponent };